import { render, staticRenderFns } from "./PackageComponents.vue?vue&type=template&id=5b1b6aa4&scoped=true"
import script from "./PackageComponents.vue?vue&type=script&lang=js"
export * from "./PackageComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b6aa4",
  null
  
)

export default component.exports